// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"230":"c53c638d","370":"e5791941","418":"868e0c23"}[chunkId] + ".css";
};